import React from "react"

import {WriteWithAiChat} from "../../../../../../gd-modules/ai-chat/write-with-ai/write-with-ai-chat"
import AiChatModule from "../../../../../../gd-modules/ai-chat/ai-chat"
import {lexicalGetSelectedText} from "../../../../actions/get-selected-text"
import AIChatContext from "../../../../../../model2/ai/chat/context/context"
import {AIChatContextType} from "../../../../../../model2/ai/@const"
import {LexicalEditor} from "lexical";
import {EditorAIOptions} from "../../../../editor";

// const debug = "ToolbarInsertMenu"
const debug = false

type Props = {
    menuParams  : {
        editor      : LexicalEditor,
        ai?         : EditorAIOptions
    }

}

export default function ToolbarInsertMenu(props:Props) {


    const selectedText: string = lexicalGetSelectedText(props.menuParams.editor)
    debug && console.log(debug, "selectedText ", selectedText)

    const module = new AiChatModule()
    module.currentAIChat   = null

    if (props.menuParams.ai?.taskId) {
        debug && console.log(debug, "taskId ", props.menuParams.ai?.taskId)
        module.chatContext     = new AIChatContext({
            type        : AIChatContextType.TASK,
            taskId      : props.menuParams.ai?.taskId,
            selectedText: selectedText
        })
    } else {
        debug && console.log(debug, "no context ")
        module.chatContext     = new AIChatContext({
            type        : AIChatContextType.ALL_SPACES,
            selectedText: selectedText
        })
    }


    return (
        <div className="ui5-popover-menu icon-fs-16 with-help">
            <WriteWithAiChat
                className   = "w-375 h-400"
                editor      = {props.menuParams.editor}
                aiOptions   = {props.menuParams.ai!}
            />
        </div>
    )
}